import { useState, useEffect, useCallback } from 'react'
import { emailService } from '../services/emailService'
import type { NotificationEmail } from '../types'

export function useNotificationEmails() {
  const [data, setData] = useState<NotificationEmail[]>([])
  const [isLoading, setIsLoading] = useState(true)
  const [error, setError] = useState<string | null>(null)

  const fetchData = useCallback(async () => {
    setIsLoading(true)
    setError(null)
    try {
      const emails = await emailService.getNotificationEmails()
      setData(emails)
    } catch (err) {
      setError(err instanceof Error ? err.message : 'Error al cargar emails de notificación')
    } finally {
      setIsLoading(false)
    }
  }, [])

  useEffect(() => {
    fetchData()
  }, [fetchData])

  return { data, isLoading, error, refetch: fetchData }
}
